export const addDebouncingEventListener = (type, callback, object = window, time = 1000) => {
	let timeout = 0;
	object.addEventListener(type, (event) => {
		if (timeout) clearTimeout(timeout);
		timeout = setTimeout(() => callback(event), time);
	});
};

export const runOnce = (fn, time = 1000) => {
	const interval = setInterval(() => {
		const success = fn();
		if (success) clearInterval(interval);
	}, time);
};

export const getInjectedData = (key) => {
	const value = window[key];
	if (value === undefined) {
		console.warn('Could not find injected data for key "' + key + '"');
		return '';
	}
	return JSON.parse(value);
};
